/* Enhancement only: policy wording and links work without JavaScript. */
(() => {
  if (customElements.get('zb-policy-page')) return;
  customElements.define('zb-policy-page', class extends HTMLElement {
    connectedCallback() {
      const body = this.querySelector('.shopify-policy__body');
      const index = this.querySelector('[data-policy-index]');
      const links = this.querySelector('[data-policy-index-links]');
      if (!body || !index || !links || links.childElementCount) return;
      const headings = [...body.querySelectorAll('h2,h3')].filter(h => h.textContent.trim());
      if (!headings.length) return;
      headings.forEach((heading, number) => {
        if (!heading.id) heading.id = `zb-policy-section-${number + 1}`;
        const link = document.createElement('a');
        link.href = `#${heading.id}`;
        link.textContent = heading.textContent.trim();
        links.append(link);
      });
      index.hidden = false;
      if (matchMedia('(max-width:749px)').matches) index.open = false;
      if (!('IntersectionObserver' in window)) return;
      this.observer = new IntersectionObserver(entries => {
        const visible = entries.filter(e => e.isIntersecting).sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);
        if (!visible.length) return;
        links.querySelectorAll('a').forEach(link => {
          if (link.hash === `#${visible[0].target.id}`) link.setAttribute('aria-current', 'location');
          else link.removeAttribute('aria-current');
        });
      }, { rootMargin: '-110px 0px -50% 0px', threshold: 0 });
      headings.forEach(heading => this.observer.observe(heading));
    }
    disconnectedCallback() { this.observer?.disconnect(); }
  });
})();
